module.exports = __webpack_public_path__ + "img/Rectanglefive3.658ecb87.png";